module.exports = __webpack_public_path__ + "static/media/avatar_ant.b5710f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_ant.png
// module id = 363
// module chunks = 0